export var GdsgInventoryReportMetadataField;
(function (GdsgInventoryReportMetadataField) {
    GdsgInventoryReportMetadataField["GDSG_INVENTORY_REPORT_METADATA_FIELD_BUCKET"] = "BUCKET";
    GdsgInventoryReportMetadataField["GDSG_INVENTORY_REPORT_METADATA_FIELD_NAME"] = "NAME";
    GdsgInventoryReportMetadataField["GDSG_INVENTORY_REPORT_METADATA_FIELD_SIZE"] = "SIZE";
    GdsgInventoryReportMetadataField["GDSG_INVENTORY_REPORT_METADATA_FIELD_UPDATED"] = "UPDATED";
    GdsgInventoryReportMetadataField["GDSG_INVENTORY_REPORT_METADATA_FIELD_ETAG"] = "ETAG";
    GdsgInventoryReportMetadataField["GDSG_INVENTORY_REPORT_METADATA_FIELD_CONTENT_TYPE"] = "CONTENT_TYPE";
    GdsgInventoryReportMetadataField["GDSG_INVENTORY_REPORT_METADATA_FIELD_CRC32C"] = "CRC32C";
    GdsgInventoryReportMetadataField["GDSG_INVENTORY_REPORT_METADATA_FIELD_STORAGE_CLASS"] = "STORAGE_CLASS";
})(GdsgInventoryReportMetadataField || (GdsgInventoryReportMetadataField = {}));
